import styled, { css } from 'styled-components'
import { Colors, Shadows } from 'cio-design-library/design-tokens'

import { Icon24 } from 'builder/components/Icon'
import { Typography } from 'builder/styles/typography'
import { SpinnerBlack } from 'builder/components/Spinner'

export const Container = styled.div<{ $isSyncing: boolean }>`
  left: 50%;
  bottom: 24px;
  z-index: 1000;
  position: fixed;
  transform: translateX(-50%);

  gap: 4px;
  display: flex;
  align-items: center;
  padding: 8px 12px 8px 8px;
  border-radius: 32px;
  background: ${Colors.White};
  box-shadow: ${Shadows.lightWithBorderShadowMid};

  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(20px);
  transition: all 500ms ease-out;

  ${({ $isSyncing }) =>
    $isSyncing &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
      transition: all 350ms ease-in-out;
    `}
`

export const SavedIcon = styled(Icon24.Saved)``
export const Spinner = styled(SpinnerBlack)`
  width: 24px;
  height: 24px;
`

export const Text = styled.div`
  ${Typography.Caption}
  color: ${Colors.Neutral80};
`
